<script setup>
import { computed } from "vue";

const props = defineProps({
  value: { type: Number, default: 0 },
  size: { type: Number, default: 13 },
});
const STAR =
  "M12 2.5l2.9 6 6.6.6-5 4.3 1.5 6.4L12 16.9 6 19.8l1.5-6.4-5-4.3 6.6-.6z";
// Rating 0 (or null/NaN) means "no rating"; show an "Unrated" label instead of
// an all-empty star row that reads as "0 stars".
const unrated = computed(() => !(Number(props.value) > 0));
const filled = (i) => i < Math.round(props.value);
</script>

<template>
  <span v-if="unrated" class="btm-stars btm-muted" style="font-size: 11px">
    Unrated
  </span>
  <span v-else class="btm-stars">
    <svg
      v-for="i in [0, 1, 2, 3, 4]"
      :key="i"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      :fill="filled(i) ? 'var(--brand)' : 'var(--surface-3)'"
    >
      <path :d="STAR" />
    </svg>
  </span>
</template>
